import type { FilterItem } from '@ctw/shared/components/filter-bar/filter-bar-types';
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';

export const THIRD_PARTY_SOURCE_SYSTEM = 'https://zusapi.com/thirdparty/source';

export const dismissFilter: FilterItem = {
  key: 'showHidden', // Special key for filtering. See utils/filters.ts.
  type: 'tag',
  belowDivider: true,
  display: ({ listView }) => (listView ? 'show dismissed records' : 'show dismissed'),
  icon: faEye,
  toggleDisplay: 'hide dismissed records',
  toggleIcon: faEyeSlash,
};
